import React from "react";

import PropTypes from "prop-types";
import { Well } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "shared/src/stores/storeConnect";
import { List } from "immutable";
import ContentSearchResultItem from "./ContentSearchResultItem";
import LoadingPanel from "../../general/LoadingPanel";
import LoadMoreButton from "../../general/LoadMoreButton";
import ContentSearchStore, { ContentSearchStoreState } from "../../../stores/ContentSearchStore";
import { trackNextContentPage } from "../../../utils/SearchTrackingUtil";
import { DEFAULT_ROWS, updatePaginationState } from "../../../utils/SearchUtil";

type Props = {
    content: ContentSearchStoreState;
};

class ContentSearchResult extends React.Component<Props> {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    renderLoadingPanel = () => {
        if (this.props.content.loading) {
            return <LoadingPanel messageId="EX_SEARCHING" />;
        }
        return null;
    };

    renderContent() {
        if (this.props.content.error) {
            return (
                <Well className="ex-search-query-badge">
                    <div className="ex-content-search-page-failed h4 no-margin">
                        <FormattedMessage id="EX_CONTENT_SEARCH_FAILED" />
                    </div>
                </Well>
            );
        }

        const items = this.props.content?.items ?? List();
        if (items.size === 0) {
            return (
                <Well className="ex-search-query-badge">
                    <div className="ex-content-search-page-no-result h4 no-margin">
                        <FormattedMessage id="EX_CONTENT_SEARCH_NO_RESULT" />
                    </div>
                </Well>
            );
        }
        return items.map((item) => <ContentSearchResultItem item={item!} key={item!.contentId} />);
    }

    loadMore = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const pageNumber = this.context.router.location?.state?.numPagesContent ?? 1;
        trackNextContentPage("CONTENT_SEARCH", pageNumber);
        updatePaginationState("numPagesContent", this.context.router);
    };

    renderLoadMoreButton() {
        const total = this.props.content?.numFound ?? List();
        if (this.props.content.loading || this.props.content?.items?.size === total) {
            return null;
        }
        const results = this.props.content;
        const totalFound = results?.numFound ?? 0;
        const currentFound = (results?.items ?? List()).size;
        return (
            <LoadMoreButton
                key="loadMoreContent"
                loadmore={(event: any) => this.loadMore(event)}
                loaded={currentFound}
                loadnext={Math.min(totalFound - currentFound, DEFAULT_ROWS)}
                amount={totalFound}
            />
        );
    }

    render() {
        return (
            <div className="ex-content-search-page">
                <div className="mfcss_flexbox-post-container">{this.renderContent()}</div>
                {this.renderLoadingPanel()}
                {this.renderLoadMoreButton()}
            </div>
        );
    }
}

const wrapped = connect(
    {
        stores: [[ContentSearchStore, (s: typeof ContentSearchStore) => ({ content: s.getState() })]]
    },
    ContentSearchResult
);

export default wrapped;
